<template>
  <div v-if="facetValues.length > 1 && hasFacetValue" class="c-facet-item">
    <button class="c-facet-item__title" @click="collapsed = !collapsed">
      <span class="h4 mb-0">
        {{ facetKey }}
      </span>
      <facet-collapse-icon :collapsed="collapsed" />
    </button>

    <div v-if="!collapsed" class="c-facet-item__body">
      <ul class="c-facet-item__list">
        <facet-value
          v-for="facetValue in facetValues"
          :key="facetValue.value + '_' + facetValue.propertyValueId"
          :facet-value="facetValue"
          :facet-key="facetKey"
          :unit="facet.metadata.unit"
        />
      </ul>

      <div
        v-if="facet.values.length > facet.metadata.defaultMaxFilterCount"
        class="c-facet-item__showmore"
        @click="showAll = !showAll"
      >
        <span v-show="showAll" class="c-facet-item__showmore--item">
          {{ getProductOverviewTranslations['ProductsOverview.ShowLess'] }}
        </span>
        <span v-show="!showAll" class="c-facet-item__showmore--item">
          {{ getProductOverviewTranslations['ProductsOverview.ShowMore'] }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FacetCollapseIcon from './facet-collapse-icon.vue';
import FacetValue from './facet-value.vue';

export default {
  name: 'Facet',
  components: {
    FacetCollapseIcon,
    FacetValue
  },
  props: {
    facet: {
      type: Object,
      required: true,
      values: {
        type: Array,
        required: true
      },
      metadata: {
        type: Object,
        required: true
      }
    },
    facetKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      collapsed: this.facet.metadata.defaultCollapse,
      showAll: false
    };
  },
  computed: {
    ...mapGetters('productSearch', ['isFilterActive']),
    ...mapGetters('translations', ['getProductOverviewTranslations']),
    sortedFacetValues() {
      const copy = [...this.facet.values];
      return copy.sort((a, b) => {
        const isFilterActiveComparison =
          this.isFilterActive(this.facetKey, b.value) -
          this.isFilterActive(this.facetKey, a.value);
        const isfilterDisabledComparison =
          a.count > 0 === b.count > 0 ? 0 : a.count > 0 ? -1 : 1;
        const propertyValueIdComparison =
          a.metadata.propertyValueId - b.metadata.propertyValueId;

        return (
          isFilterActiveComparison ||
          isfilterDisabledComparison ||
          propertyValueIdComparison
        );
      });
    },
    facetValues() {
      if (this.showAll) return this.sortedFacetValues;
      return this.sortedFacetValues.slice(
        0,
        this.facet.metadata.defaultMaxFilterCount
      );
    },
    hasFacetValue() {
      return this.facetValues.some(x => x?.count > 0);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '@/css/src/utilities/_mixins.scss';
@import '~bootstrap/scss/mixins';

.c-facet-item {
  display: flex;
  flex-direction: column;

  &__title {
    @include button-reset();

    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1;
    padding-bottom: 10px;
    border-bottom: 1px solid $grey;
  }

  &__body {
    padding-top: 20px;
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__showmore {
    margin-top: 12px;

    &--item {
      cursor: pointer;
      color: $primary;
      text-decoration: underline;
      font-size: 14px;
    }
  }
}
</style>
